
const features = [
  { icon: 'mdi-alarm', title: 'shifts', name: 'shifts', description: 'track_cash_that_goes_in_and_out_of_your_drawer' },
  { icon: 'mdi-cash-multiple', title: 'prices', name: 'prices', description: 'multi_prices' },
  { icon: 'mdi-warehouse', title: 'add_from_warehause', name: 'add_from_warehause', description: 'add_items_from_warehause_quickly' },
  { icon: 'mdi-cash-usd', title: 'nds', name: 'nds', description: '' },
  { icon: 'mdi-timer', title: 'time_clock', name: 'time_clock', description: 'track_employees_clock_in_out_time_and_calculate_their_total_work_hours' },
  { icon: 'mdi-ticket', title: 'open_tickets', name: 'open_tickets', description: 'allow_to_save_and_edit_orders_before_completing_a_payment' },
  { icon: 'mdi-cash-multiple', title: 'debts', name: 'debts', description: 'show_my_debts' },
  {
    icon: 'mdi-bookmark-outline', title: 'orders', name: 'orders', description:
      'show_customer_order_section_and_and_get_orders'
  },
  { icon: 'mdi-chat-outline', title: 'chat', name: 'chat', description: 'show_support_chat_section' },
  { icon: 'mdi-scale', title: 'scale', name: 'scale', description: 'connect_to_scale_for_markets' },
  { icon: 'mdi-shape-outline', title: 'section', name: 'section', description: 'enable_the_bar_printers' },
  { icon: 'mdi-database-check', title: 'inventory', name: 'inventory', description: 'inventery_menegment' },
  { icon: 'mdi-cash-multiple', title: 'use_purchase_cost_on_pricing', name: 'use_purchase_cost_on_pricing', description: 'use_purchase_cost_on_pricing' },
  { icon: 'mdi-home-group', title: 'client_debt_by_category', name: 'client_debt_by_category', description: 'client_debt_by_category' },
  { icon: 'mdi-bike', title: 'delivery', name: 'delivery', description: 'delivery' },
  { icon: 'mdi-currency-usd-off', title: 'show_stock', name: 'show_stock', description: 'show_stock' },
]

const feature = {
  debts: false,
  shifts: false,
  orders: false,
  prices:false,
  chat: false,
  open_tickets: false,
  time_clock: false,
  scale: false,
  section: false,
  inventory: false,
  is_local_server: false,
  show_stock: false,
  delivery: false
}

export default {
  features,
  feature
}
